export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Cognito's exact allowed special characters
// See: https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
const COGNITO_SPECIAL_CHARS = /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=\s]/;
// Full set of allowed password characters (letters, digits, and Cognito special chars)
const COGNITO_ALLOWED_CHARS = /^[a-zA-Z0-9\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=\s]+$/;

export const validatePassword = (password: string): {
  isValid: boolean;
  errors: string[];
} => {
  const errors: string[] = [];

  if (password.length < 14) {
    errors.push('Password must be at least 14 characters long');
  }

  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }

  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }

  if (!/\d/.test(password)) {
    errors.push('Password must contain at least one number');
  }

  if (!COGNITO_SPECIAL_CHARS.test(password)) {
    errors.push('Password must contain at least one special character (!@#$%^&* etc.)');
  }

  if (password.length > 0 && !COGNITO_ALLOWED_CHARS.test(password)) {
    errors.push('Password contains unsupported characters');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

export const validatePhone = (phone: string): boolean => {
  const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
  return phoneRegex.test(phone);
};

export const formatPhoneNumber = (value: string): string => {
  const numbers = value.replace(/\D/g, '');

  if (numbers.length <= 3) {
    return numbers;
  } else if (numbers.length <= 6) {
    return `(${numbers.slice(0, 3)}) ${numbers.slice(3)}`;
  } else {
    return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`;
  }
};

export const validateName = (name: string): boolean => {
  const nameRegex = /^[a-zA-Z\s\-']+$/;
  return name.length >= 1 && name.length <= 50 && nameRegex.test(name);
};

export const validateTitle = (title: string): boolean => {
  return title.length >= 2 && title.length <= 100;
};
